import {inject} from '@angular/core';
import {ResolveFn} from '@angular/router';
import {select, Store} from '@ngrx/store';
import {take} from 'rxjs/operators';
import {CartItem} from '../../data/model';
import {filterNullOrUndefined} from '../service';
import * as cartSelectors from './cart.selectors';

export const resolveCartItems: ResolveFn<CartItem[]> = () => {
  const store: Store = inject(Store);
  return store.pipe(
    select(cartSelectors.selectCartItems),
    filterNullOrUndefined(),
    take(1),
  );
};
